import type { SVGProps } from 'react';

export const ThumbsDownOutlined = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      {...props}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.62402 13.1748L5.67725 8.17994C5.41098 7.49677 4.75285 7.04692 4.01962 7.04692H3.65109C3.17714 7.04692 2.79292 6.66271 2.79292 6.18876V2.66818C2.79292 2.19422 3.17714 1.81001 3.65109 1.81001H9.98818C10.8569 1.81001 11.5922 2.45178 11.7095 3.31258L12.1895 6.83322C12.3317 7.87631 11.5209 8.80515 10.4682 8.80515H9.6964C8.71384 8.80515 7.91732 9.60168 7.91732 10.5842V12.7595C7.91732 12.9512 7.79491 13.1143 7.62402 13.1748ZM6.01375 14C6.24876 14.603 6.82964 15 7.47681 15C8.7142 15 9.71731 13.9969 9.71731 12.7595V10.6052H10.4682C12.6117 10.6052 14.2626 8.71391 13.973 6.59007L13.493 3.06943C13.2541 1.31673 11.7571 0.0100079 9.98818 0.0100079H3.65109C2.18302 0.0100079 0.99292 1.20011 0.99292 2.66818V6.18876C0.99292 7.65682 2.18302 8.84692 3.65109 8.84692H4.00532L6.01375 14L6.84883 13.6745L6.85231 13.6732M6.01375 14L6.84883 13.6745L6.01375 14Z"
        fill="currentColor"
      />
    </svg>
  );
};
